import useXFetch from '~/composables/useXFetch'
import { VIP_API_V1, getRtcToken } from './common'

export interface GetGoodListParams {
  /**
   * acceptTypes { Array } 期望拉取商品的类型
   * recurring: 订阅类型付费，定期扣款
   * one_time: 单次购买付费，单次扣款
   */
  acceptTypes?: ['recurring', 'one_time']
  /** 使用场景 */
  scene?: string
}
/**
 * 拉取在售商品列表
 * @returns
 */
export const getGoodsList = async (params?: GetGoodListParams, language?: string) => {
  const ipToken = await getRtcToken()
  return useXFetch(`${VIP_API_V1}/pay/products`, {
    method: 'POST',
    body: {
      accept_types: params?.acceptTypes,
      scene: params?.scene,
    },
    headers: {
      'Accept-Language': language,
      'x-system-language': import.meta.client ? navigator.language : language,
      'x-rtc-token': ipToken,
    },
    withCredentials: true,
  })
}

/**
 *  拉取在售商品列表, 主要给官网用, 该接口服务端不鉴权
 * @returns
 */
export const getGoodsListWithoutAuth = async (scene?: string, language?: string) => {
  const ipToken = await getRtcToken()
  return useXFetch(`${VIP_API_V1}/pay/products?scene=${scene}`, {
    method: 'GET',
    headers: {
      'Accept-Language': language,
      'x-system-language': import.meta.client ? navigator.language : language,
      'x-rtc-token': ipToken,
    },
  })
}

export interface SignInListDetail {
  data: Array<{ time: string; reward_days: number }>
  total_reward_days: number
  consecutive_checkin_days: number
  bot_checked: boolean
}

/**
 * 获取签到列表
 * @param limit  页面
 */
export const getSignInList = async (limit = 5) => useXFetch<SignInListDetail>(`${VIP_API_V1}/activity/signInList?limit=${limit}`, {
    method: 'GET',
    withCredentials: true,
  })

export interface CouponListProps {
  result: Array<{
    couponType: 'DISCOUNT_YEARLY' | 'DISCOUNT_MONTHLY'
    discount: number
    expiresAt: string
    status: string
  }>
}
/**
 * 获取优惠券列表
 */
export const getCouponList = async () => useXFetch<CouponListProps>(`${VIP_API_V1}/activity/coupons`, {
    method: 'GET',
    withCredentials: true,
  })
